import MDBox from "components/atoms/MDBox/MDBox"
import { FormValues } from "../SignUpPage"
import MDTypography from "components/atoms/MDTypography/MDTypography"
import MDInput from "components/atoms/MDInput/MDInput"
import MDButton, { MDButtonVariants } from "components/atoms/MDButton/MDButton"
import { MUIBaseColors, MUIBaseVariants, MUIColors } from "models/StyleModels"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons"
import { useLocation } from "react-router-dom"

import HttpService from 'services/httpService';
import { ENDPOINT_BASE_URL } from 'hooks/constants';

// AWS Cognito Authentication
import UserPool from 'services/cognitoUserPoolService';
import { AuthenticationDetails, CognitoUser } from 'amazon-cognito-identity-js';
import { useState } from "react"
import colors from "assets/theme/base/colors"
import { OrgRole } from "models/OrgModels"
import { useAuth } from "hooks/useAuth"

interface TempPasswordVerifyStepProps {
    next: () => void
    back: () => void
    formValues: FormValues
    handleChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
    inviteEmail: string | null
}

const TempPasswordVerifyStep: React.FC<TempPasswordVerifyStepProps> = ({
    next,
    back,
    formValues,
    handleChange,
    inviteEmail
}) => {
    const [validationErrors, setValidationErrors] = useState('');
    const [requestLoading, setRequestLoading] = useState<boolean>(false);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const inviteId = queryParams.get('invite');
    const username = queryParams.get('username');

    const {
        signIn,
    } = useAuth();

    const handleInviteSignUp = async (event: React.FormEvent) => {
        event.preventDefault();

        if (inviteEmail) {
            const { password } = formValues
            const email = inviteEmail

            const cognitoUser = new CognitoUser({ Username: email, Pool: UserPool });

            const authData = {
                Username: email,
                Password: password,
            };

            const authDetails = new AuthenticationDetails(authData);

            cognitoUser.authenticateUser(authDetails, {
                onSuccess: async () => {
                    cognitoUser.getSession(async (err: Error | null, session: any) => {
                        if (err) {
                            setRequestLoading(false);
                            setValidationErrors('Something went wrong.');
                        }

                        const token = session?.accessToken.jwtToken;

                        const roleData = await HttpService.get<{ role: OrgRole }>({
                            url: `${ENDPOINT_BASE_URL}/accept-invite/?invite_id=${inviteId}&email=${inviteEmail}&name=${username}`,
                            token: token,
                        });

                        const role = roleData?.data?.role;

                        if (!role) {
                            next();
                        } else {
                            await signIn({ username: email, password })
                        }
                    });
                },
                onFailure: (err) => {
                    setRequestLoading(false);
                    setValidationErrors('Something went wrong.');
                },
            });
        }

    }

    return (
        <MDBox>
            <MDBox
                id='signup'
                component='form'
                role='form'
                onSubmit={handleInviteSignUp}
            >
                <MDBox lineHeight={0} pb={3} px={3} mb={2} textAlign='center' display={validationErrors === '' ? 'none' : 'block'}>
                    <MDTypography variant='button' color={MUIColors.ERROR}>
                        {validationErrors}
                    </MDTypography>
                </MDBox>

                <MDBox mb={2}>
                    <MDTypography color={MUIColors.WHITE}>
                        {inviteEmail}
                    </MDTypography>
                </MDBox>

                <MDBox mb={2}>
                    <MDInput style={{ outline: 'white' }}
                        name="password"
                        label='Temporary Password'
                        type='password'
                        value={formValues.password}
                        fullWidth
                        onChange={(event) => handleChange(event)} />
                </MDBox>

                <MDBox mt={4}>
                    <MDButton
                        variant={MDButtonVariants.GRADIENT as unknown as MUIBaseVariants}
                        color={MUIColors.LIGHT as unknown as MUIBaseColors}
                        type='submit'
                        fullWidth
                    >
                        {requestLoading ? <FontAwesomeIcon icon={faCircleNotch} color='grey' spin /> : 'Sign up'}
                    </MDButton>
                </MDBox>

                <MDBox mt={3} textAlign='center'>

                    <MDButton
                        variant='text'
                        style={{ textDecoration: 'underline', color: colors.white.main }}
                        onClick={back}
                    >
                        Back
                    </MDButton>
                </MDBox>
            </MDBox>
        </MDBox>
    )
}

export default TempPasswordVerifyStep 